<template>
  <div>
    
    <div v-if="!isAutoLogin" style="margin-top: 50px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div 
            style="margin-top: 50px; display: flex; 
            flex-direction: column; 
            width: 400px; 
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
            padding: 20px;
            justify-content: center; align-items: center;">

                <img alt="Don Quijote Recepciones Logo" :src="getTopLogo" style="max-width: 250px; ">

                <div style="margin-top: 50px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label" v-html="'Email'"></span>
                    <el-input @focus="$event.target.select()"
                        id="loginId"
                        v-model.trim="email" @keyup.enter.native="login">
                    </el-input>
                </div>
                <div style="margin-top: 20px; display: flex; flex-direction: column; width: 80%;  justify-content: flex-start; align-items: flex-start;">
                    <span type="label" v-html="'Documento de identidad'"></span>
                    <el-input @focus="$event.target.select()"
                        id="loginPassword"
                        type="password"
                        show-password
                        v-model.trim="password" @keyup.enter.native="login">
                    </el-input>
                </div>

                <div style="margin-top: 20px; display: flex; flex-direction: row; width: 80%;  justify-content: space-between; align-items: space-between;">
                    <el-button :loading="$store.getters.getLoadingState" @click="login" type="primary" size="small"><span v-html="'Iniciar Sesión'"></span></el-button>
                </div>

                <div v-if="!isMobileDevice" style="width: 100%; text-align: center; margin-top: 50px;">
                    <span>
                        Para una cuenta nueva, por favor <el-link href="https://donquijoterecepciones.com/contacto"><b v-html="'contáctenos'"></b></el-link>.
                    </span>
                </div>

        </div>
    </div>
        
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
    data() {
        return {
            processing: false,
            hideMasterLogin: true,
            email: '',
            password: ''
        }
    },
    computed: {
        getTopLogo() {
            let logo = "https://donquijote.b-cdn.net/dq-black-logo.png"
            return logo
        },
        isMobileDevice() {
            return isMobile
        },
        isProcessing() {
            return this.processing
        },
        isMasterLoginHidden() {
            return this.hideMasterLogin
        },
        isAutoLogin() {
            return this.$route.query.auto_login
        }
    },
    methods: {
        login() {
            
            if(this.email.length === 0) {
                this.$alert('Falta el Email', 'Warning', {
                    confirmButtonText: 'OK',
                    type: 'warning'
                }).then(() => {
                    
                }).catch(() => {
                        
                });
                return
            } else if(this.password.length === 0) {
                this.$alert('Falta la contraseña', 'Warning', {
                    confirmButtonText: 'OK',
                    type: 'warning'
                }).then(() => {
                    
                }).catch(() => {
                        
                });
                return
            }

            this.processing = true

            this.$store.dispatch('login', {email: this.email, password: this.password})

            setTimeout(() => {
                this.processing = false
            }, 1000);
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.$route.query.auto_login) {
                /*this.email = this.$route.query.email
                this.password = this.$route.query.password

                setTimeout(() => {
                    this.login()
                }, 300);*/

                localStorage.setItem('accessToken', this.$route.query.authToken)  
                window.location = '/'
            }
        }, 1000);
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Session/Login.vue